import React from 'react';
import { Alert, Form, Icon, Input, Button, Row, Col } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import { resetPassword, loginTwoFactor } from '../../reducers/user/actions';
import {getUserToken} from "../../reducers/user/selectors";
import {
  createRegistryIDProfileRequest,
  updateRegistryIDProfileRequest,
} from '../../api/requests';

import classes from './PatientProfileForm.css';

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class PatientRegistryForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      checkConfirmRequestError: '',
      username: '',
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });

      if (!err) {
        this.setState({ isLoading: true, errorMessage: null, responseMessage: null });

        try {
          const registry = {...values};

          if (this.props.profile) {
            await updateRegistryIDProfileRequest(this.props.subjectID, registry);
          } else {
            await createRegistryIDProfileRequest(this.props.subjectID, registry);
          }

          this.setState({ responseMessage: 'Success' });

          setTimeout(() => {
            this.props.onSubmit(this.props.subjectID);
          }, 1500);
        } catch (err) {
          this.setState({ errorMessage: get(err, 'response.data.error', get(err, 'response.data.errors._schema[0]')), isLoading: false});
        }
      }
    });
  };


  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const { isLoading, errorMessage, responseMessage, checkConfirmRequestError } = this.state;

    return (
      <div className={classes.patientProfileForm}>
        <Form onSubmit={this.handleSubmit}>
          <Row gutter={8}>
            <Col sm={6}>
              <label>
                <b>QUICR Registry ID</b>
                <Form.Item>
                  {getFieldDecorator('quicr_registry_id', {
                    initialValue: get(this.props, 'profile.quicr_registry_id', '')
                  })(
                    <Input />,
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col sm={6}>
              <label>
                <b>Optimize Registry ID</b>
                <Form.Item>
                  {getFieldDecorator('optimize_registry_id', {
                    initialValue: get(this.props, 'profile.optimize_registry_id', '')
                  })(
                    <Input />,
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {errorMessage && <Alert message={errorMessage} type="error" className={classes.alertsMb} />}
          {responseMessage && <Alert message={responseMessage} type="success" className={classes.alertsMb} />}
          {checkConfirmRequestError && <Alert message={checkConfirmRequestError} type="error" className={classes.alertsMb} />}

          {!responseMessage && !checkConfirmRequestError && (<Row gutter={12}>
            <Col span={12}>
              <Form.Item>
                <Button type="primary" size="large" htmlType="submit" disabled={hasErrors(getFieldsError())} className={classes.submitButton}>
                  Save
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Form.Item>
            </Col>
          </Row>)}

        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userToken: getUserToken(state),
});

const mapDispatchToProps = {
  resetPassword,
  loginTwoFactor,
};

export default Form.create({ name: 'patientRegistryForm' })(connect(mapStateToProps, mapDispatchToProps)(PatientRegistryForm));



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientRegistryForm.js